import { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonSelect } from "../../Input";
import DataTable from "../../table/DataTable";
import DetailFieldWrapper from "../SendTransaction/DetailFieldWrapper";

// Import bill images
import bill100 from "../../../../images/cash/100_dollar.png";
import bill10 from "../../../../images/cash/10_dollar.png";
import bill1 from "../../../../images/cash/1_dollar.png";
import bill20 from "../../../../images/cash/20_dollar.png";
import bill50 from "../../../../images/cash/50_dollar.png";
import bill5 from "../../../../images/cash/5_dollar.png";
import coin1 from "../../../../images/cash/1_dollar_bronze.png";
import coin50c from "../../../../images/cash/50_cents.png";
import coin25c from "../../../../images/cash/25_cents.png";
import coin10c from "../../../../images/cash/10_cents.png";
import coin5c from "../../../../images/cash/5_cents.png";
import coin1c from "../../../../images/cash/1_cent.png";

const Step5TransactionDenomination = () => {
  const [inQuantities, setInQuantities] = useState({});
  const [outQuantities, setOutQuantities] = useState({});

  const denominations = [
    {
      id: "bill100",
      label: "100 Dollars",
      value: 100,
      type: "bill",
      image: bill100,
      inventory: 8,
    },
    {
      id: "bill50",
      label: "50 Dollars",
      value: 50,
      type: "bill",
      image: bill50,
      inventory: 22,
    },
    {
      id: "bill20",
      label: "20 Dollars",
      value: 20,
      type: "bill",
      image: bill20,
      inventory: 63,
    },
    {
      id: "bill10",
      label: "10 Dollars",
      value: 10,
      type: "bill",
      image: bill10,
      inventory: 42,
    },
    {
      id: "bill5",
      label: "5 Dollars",
      value: 5,
      type: "bill",
      image: bill5,
      inventory: 29,
    },
    {
      id: "bill1",
      label: "1 Dollar",
      value: 1,
      type: "bill",
      image: bill1,
      inventory: 32,
    },
    {
      id: "coin1",
      label: "1 Dollar",
      value: 1,
      type: "coin",
      inventory: 32,
      image: coin1,
    },
    {
      id: "coin50c",
      label: "50 Cents",
      value: 0.5,
      type: "coin",
      inventory: 21,
      image: coin50c,
    },
    {
      id: "coin25c",
      label: "25 Cents",
      value: 0.25,
      type: "coin",
      inventory: 45,
      image: coin25c,
    },
    {
      id: "coin10c",
      label: "10 Cents",
      value: 0.1,
      type: "coin",
      inventory: 51,
      image: coin10c,
    },
    {
      id: "coin5c",
      label: "5 Cents",
      value: 0.05,
      type: "coin",
      inventory: 129,
      image: coin5c,
    },
    {
      id: "coin1c",
      label: "1 Cent",
      value: 0.01,
      type: "coin",
      inventory: 0,
      image: coin1c,
    },
  ];

  const handleInChange = (id, val) =>
    setInQuantities({ ...inQuantities, [id]: parseInt(val) || 0 });
  const handleOutChange = (id, val) =>
    setOutQuantities({ ...outQuantities, [id]: parseInt(val) || 0 });

  const getColumns = (type, quantities, onChange) => [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4 align-middle",
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded overflow-hidden bg-white"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div
              className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
              style={{
                width: "20px",
                height: "20px",
                fontSize: "8px",
                backgroundColor: item.id.includes("coin1")
                  ? "#FFC107"
                  : "#E2E8F0",
                color: item.id.includes("coin1") ? "#fff" : "#64748B",
                border: "1px solid rgba(0,0,0,0.05)",
              }}
            >
              $
            </div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      className: "align-middle",
      render: (item) => (
        <span className="fs-12 fw-bold text-black">{item.label}</span>
      ),
    },
    ...(type === "out"
      ? [
          {
            label: "INVENTORY",
            key: "inventory",
            className: "align-middle text-center",
            render: (item) => (
              <span className="fs-12 fw-medium text-muted d-flex align-items-center justify-content-center gap-2">
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: item.inventory > 0 ? "#10B981" : "#EF4444",
                    display: "inline-block",
                  }}
                ></span>
                {item.inventory}
              </span>
            ),
          },
        ]
      : []),
    {
      label: "QUANTITY",
      key: "quantity",
      className: "align-middle text-center px-2",
      render: (item) => (
        <input
          type="number"
          className="form-control text-center mx-auto"
          style={{
            height: "36px",
            width: "80px",
            fontSize: "14px",
            fontWeight: "600",
            backgroundColor: "#fff",
            border: "1px solid #E2E8F0",
            borderRadius: "6px",
            color: "#0A2540",
          }}
          value={quantities[item.id] || 0}
          placeholder="0"
          onChange={(e) => onChange(item.id, e.target.value)}
        />
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4 align-middle",
      render: (item) => (
        <div className="text-end fw-bold fs-13 text-black">
          SGD {(item.value * (quantities[item.id] || 0)).toFixed(2)}
        </div>
      ),
    },
  ];

  return (
    <div className="mt-4 pb-2">
      {/* Search Header Design */}
      <div className="mb-4">
        <Row className="g-4">
          <Col md={4}>
            <DetailFieldWrapper label="Payment Method">
              <CommonSelect
                placeholder="Cash"
                options={[{ value: "cash", label: "Cash" }]}
              />
            </DetailFieldWrapper>
          </Col>
          <Col md={4}>
            <DetailFieldWrapper label="Total Paid">
              <div
                className="d-flex align-items-center bg-white rounded px-3"
                style={{ height: "45px", border: "1px solid #e5e7eb" }}
              >
                <span className="text-muted fs-14 fw-bold me-3">SGD</span>
                <span className="fw-bold text-black fs-14">6</span>
              </div>
            </DetailFieldWrapper>
          </Col>
          <Col md={4}>
            <DetailFieldWrapper label="Change Amount">
              <div
                className="d-flex align-items-center bg-white rounded px-3"
                style={{ height: "45px", border: "1px solid #e5e7eb" }}
              >
                <span className="text-muted fs-14 fw-bold me-3">SGD</span>
                <span className="fw-bold text-black fs-14">0.00</span>
              </div>
            </DetailFieldWrapper>
          </Col>
        </Row>
      </div>

      <Row className="g-4">
        {/* Left Column: Cash In */}
        <Col lg={6}>
          <div className="d-flex mb-3">
            <div
              className="bg-white py-2 px-4 border border-light d-flex flex-column justify-content-center text-center mx-auto mx-lg-0"
              style={{ minHeight: "70px", borderRadius: "12px" }}
            >
              <div
                className="text-muted mb-1"
                style={{ fontSize: "10px", letterSpacing: "0.02em" }}
              >
                Actual Cash Receive
              </div>
              <div className="fw-bold text-black fs-14">SGD 0</div>
            </div>
          </div>
          <div className="card shadow-sm rounded-4 overflow-hidden border-0">
            <DataTable
              columns={getColumns("in", inQuantities, handleInChange)}
              data={denominations}
              showPagination={false}
              minWidth="100%"
            />
          </div>
        </Col>

        {/* Right Column: Calculations and Change Out */}
        <Col lg={6}>
          <div className="d-flex w-100 mb-3">
            <div
              className="bg-white py-2 px-3 px-xl-4 border d-flex align-items-center justify-content-between flex-grow-1"
              style={{ minHeight: "70px", borderRadius: "12px" }}
            >
              <div className="d-flex flex-column align-items-center px-1">
                <span
                  className="text-muted text-uppercase mb-1 text-center"
                  style={{ fontSize: "10px" }}
                >
                  Cash Transfer
                  <br />
                  Amount
                </span>
                <span className="fw-bold text-black fs-14">6 SGD</span>
              </div>
              <div
                className="border-start mx-1 mx-xl-2"
                style={{ height: "30px" }}
              ></div>
              <div className="d-flex flex-column align-items-center px-1">
                <span
                  className="text-muted text-uppercase mb-1 text-center"
                  style={{ fontSize: "10px" }}
                >
                  Actual Cash
                  <br />
                  Receive
                </span>
                <span className="fw-bold text-black fs-14">0 SGD</span>
              </div>
              <div
                className="border-start mx-1 mx-xl-2"
                style={{ height: "30px" }}
              ></div>
              <div className="d-flex flex-column align-items-center px-1">
                <div className="position-relative mb-1">
                  <span
                    className="text-muted text-uppercase text-center d-block"
                    style={{ fontSize: "10px" }}
                  >
                    Expected
                    <br />
                    Change
                  </span>
                  <Badge
                    bg="success"
                    className="position-absolute bg-opacity-10 text-success border-success border rounded-pill"
                    style={{
                      left: "100%",
                      top: "50%",
                      transform: "translateY(-50%)",
                      marginLeft: "6px",
                      fontSize: "8px",
                      padding: "2px 5px",
                    }}
                  >
                    Rounded
                  </Badge>
                </div>
                <span className="fw-bold text-black fs-14">0 SGD</span>
              </div>
              <div
                className="border-start mx-1 mx-xl-2"
                style={{ height: "30px" }}
              ></div>
              <div className="d-flex flex-column align-items-center px-1">
                <span
                  className="text-muted text-uppercase mb-1 text-center"
                  style={{ fontSize: "10px" }}
                >
                  Actual
                  <br />
                  Change
                </span>
                <span className="fw-bold text-black fs-14">SGD 0</span>
              </div>
            </div>
          </div>
          <div className="card shadow-sm rounded-4 overflow-hidden border-0">
            <DataTable
              columns={getColumns("out", outQuantities, handleOutChange)}
              data={denominations}
              showPagination={false}
              minWidth="100%"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Step5TransactionDenomination;
